import { take, put, race } from 'redux-saga/effects';
import { Modal } from 'antd';
const {confirm} = Modal;

export default function confirmSaga(confirmationMessage) {
    // Cause the dialog to be shown (reducer will put the message
    // in the store; the main shell UI component will receive the
    // message in its props and then display the dialog) 
    // yield put(showConfirmation(confirmationMessage));
    // Wait for either a yes or a no.
    // The dialog UI component receives yes and no event handlers
    // in its props that dispatch these actions.
    return new Promise((resolve, reject) => {
        confirm({
            title: confirmationMessage,
            content: '',
            onOk() {
                resolve("Ok")
            },
            onCancel() {
                resolve("Cancel")
            },
        });
    }) 
    // Tell a reducer to hide the dialog
    // yield put(hideConfirmation());
    // Returns true if the 'yes' action was received
    return;
}